import type {
  GiantItemsLayout,
  LevelBoosterPlacement,
  LevelObjectPlacement,
  LevelRouteMetrics,
} from './itemsLayout';

/** Authoring layout SVG viewBox (`1.svg` / `2.svg` / `3.svg`). */
export const LAYOUT_SVG_VIEWBOX_WIDTH = 13671;
export const LAYOUT_SVG_VIEWBOX_HEIGHT = 930;

/** Runtime / art viewBox matching `background.png` (6276×428). */
export const LEVEL_ART_VIEWBOX_WIDTH = 6276;
export const LEVEL_ART_VIEWBOX_HEIGHT = 428;

export const LAYOUT_SCALE_X = LEVEL_ART_VIEWBOX_WIDTH / LAYOUT_SVG_VIEWBOX_WIDTH;
export const LAYOUT_SCALE_Y = LEVEL_ART_VIEWBOX_HEIGHT / LAYOUT_SVG_VIEWBOX_HEIGHT;

export function scaleLayoutSvgX(svgX: number): number {
  return svgX * LAYOUT_SCALE_X;
}

export function scaleLayoutSvgY(svgY: number): number {
  return svgY * LAYOUT_SCALE_Y;
}

function scalePlacement<T extends LevelObjectPlacement>(item: T): T {
  return { ...item, s: item.s * LAYOUT_SCALE_X };
}

function scaleRoute(route: LevelRouteMetrics): LevelRouteMetrics {
  const sx =
    route.viewBoxWidth > 0 ? LEVEL_ART_VIEWBOX_WIDTH / route.viewBoxWidth : LAYOUT_SCALE_X;
  const sy =
    route.viewBoxHeight > 0 ? LEVEL_ART_VIEWBOX_HEIGHT / route.viewBoxHeight : LAYOUT_SCALE_Y;
  return {
    ...route,
    viewBoxWidth: LEVEL_ART_VIEWBOX_WIDTH,
    viewBoxHeight: LEVEL_ART_VIEWBOX_HEIGHT,
    startPointSvgX: route.startPointSvgX * sx,
    spawnSvgX: route.spawnSvgX * sx,
    spawnSvgY: route.spawnSvgY * sy,
    routeEndS: route.routeEndS * sx,
    finishCourierPlaceSvgX: route.finishCourierPlaceSvgX * sx,
    finishCourierPlaceSvgY: route.finishCourierPlaceSvgY * sy,
  };
}

/** Maps a layout parsed from authoring SVG (13671×930) onto the art viewBox. */
export function scaleGiantItemsLayoutToArt(layout: GiantItemsLayout): GiantItemsLayout {
  return {
    ...layout,
    route: scaleRoute(layout.route),
    staticObstacles: layout.staticObstacles.map(scalePlacement),
    movingObstacles: layout.movingObstacles.map(scalePlacement),
    boosters: layout.boosters.map((item) => scalePlacement(item) as LevelBoosterPlacement),
    sparks: layout.sparks.map(scalePlacement),
  };
}
